<template>
    <div> 
        <div class="survey-module-right-action">
            <div class="table-controls justify-between">
              <div class="table-controls-btn align-center justify-between">
                <!-- <div class="table-controls-btn-item btn-color1" @click="handleOpen()">新增</div> -->
                 <span></span>
                <div class="align-center justify-between">
                  <div class="table-controls-btn-item btn-color3" @click="handleQuery()">搜索</div>
                  <div class="table-controls-btn-item btn-color4" @click="resetQuery()">重置</div>
                </div>
              </div>
            </div>
            <div class="table-controls justify-between">
              <div class="table-controls-btn justify-between">
                <!-- <div class="select-box">
                  <select v-model="queryParams.oldFlag" @change="handleQuery()">
                    <option :value="0">进行中</option>
                    <option :value="1">已存档</option>
                  </select>
                </div> -->
                <input type="text" v-model="queryParams.name" placeholder="请输入考试名称" autocomplete="off">
              </div>
            </div>
            <div class="table-body">
              <el-table
                v-loading="loading"
                ref="multipleTable"
                :data="tableData"
                tooltip-effect="dark"
                style="width: 100%"
                :header-cell-style="{background:'#72b701',color:'#fff'}"
              >
                <el-table-column prop="name" min-width="150" label="考试名称" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column min-width="400" label="考试报名时间" align="center" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    {{ scope.row.registrationStartTime + '至' +scope.row.registrationEndTime }}
                  </template>
                </el-table-column>
                <el-table-column min-width="400" label="理论考试时间" align="center" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    {{ scope.row.theoryStartTime + '至' +scope.row.theoryEndTime }}
                  </template>
                </el-table-column>
                <el-table-column min-width="400" label="实操考试时间" align="center" :show-overflow-tooltip="true">
                  <template slot-scope="scope">
                    {{ scope.row.operationStartTime + '至' +scope.row.operationEndTime }}
                  </template>
                </el-table-column>
                <el-table-column min-width="200" prop="remark" label="备注" align="center" :show-overflow-tooltip="true"></el-table-column>
                <el-table-column
                  fixed="right"
                  label="操作"
                  width="80"  
                  align="center">
                  <template slot-scope="scope">
                    <!-- <el-button @click="handleCommand(1,scope.row.id)" type="text" size="small">考生管理</el-button> -->
                    <el-button type="text" size="small" @click="handleCommand(1,scope.row.id,scope.row.type)">考生管理</el-button>

                    <!-- <el-button @click="handleOpen(scope.row)" type="text" size="small" v-if="queryParams.oldFlag===0">编辑</el-button>
                    <el-button type="text" size="small">
                      <el-dropdown @command="handleCommand($event,scope.row.id)">
                        <span class="el-dropdown-link">
                          <el-button type="text" size="small">更多</el-button>
                        </span>
                        <el-dropdown-menu slot="dropdown">
                          <el-dropdown-item :command="1">考生管理</el-dropdown-item>
                          <el-dropdown-item :command="3">成绩管理</el-dropdown-item>
                          <el-dropdown-item :command="4">证书管理</el-dropdown-item>
                          <el-dropdown-item :command="5" v-if="queryParams.oldFlag===0">存档</el-dropdown-item>
                          <el-dropdown-item :command="6" v-if="queryParams.oldFlag===0">删除</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </el-button> -->
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="pagination-content justify-end">
                <el-pagination
                  @current-change="handleCurrentChange"
                  :current-page="queryParams.pageNum"
                  :page-size="queryParams.pageSize"
                  background
                  :pager-count="5"
                  layout="prev, pager, next"
                  prev-text="上一页"
                  next-text="下一页"
                  :total="total">
                </el-pagination>
            </div>
        </div>
        <el-dialog
          :title="dialog.title"
          :visible.sync="dialog.visible"
          width="95%"
          :before-close="closeDialog"
          >
          <div class="login-form-box">
            <el-form :model="referForm" :rules="referRules" ref="referForm">
              <el-form-item prop="name">
                <input v-model="referForm.name" placeholder="考试名称" autocomplete="new-password">
              </el-form-item>
              <el-form-item prop="registrationTime">
                <el-date-picker
                  class="login-form-box-picker"
                  style="width: 100%;"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="referForm.registrationTime"
                  type="datetimerange"
                  range-separator="-"
                  start-placeholder="报名"
                  end-placeholder="时间"
                   :editable="false"
                >
                </el-date-picker>
              </el-form-item>
              <el-form-item prop="theoryTime">
                <el-date-picker
                  class="login-form-box-picker"
                  style="width: 100%;"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="referForm.theoryTime"
                  type="datetimerange"
                  range-separator="-"
                  start-placeholder="理论考试"
                   :editable="false"
                  end-placeholder="时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item prop="operationTime">
                <el-date-picker
                  class="login-form-box-picker"
                  style="width: 100%;"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  v-model="referForm.operationTime"
                  type="datetimerange"
                  range-separator="-"
                  start-placeholder="实操考试"
                   :editable="false"
                  end-placeholder="时间">
                </el-date-picker>
              </el-form-item>
              <el-form-item prop="remark">
                <input v-model="referForm.remark" placeholder="备注" autocomplete="new-password">
              </el-form-item>
              <el-form-item>
                <div class="login-form-btn justify-center align-center" @click="handleSubmit('referForm')">提交{{ dialog.title }}</div>
              </el-form-item>
            </el-form>
           </div>
        </el-dialog>
    </div>
  </template>
  
  <script>
  import { getList, addItem, editItem, delItem,documenItem } from "@/api/ksgl";
  export default {
    data(){
      return{
        loading:false,
        queryParams:{
          pageNum: 1,
          pageSize: 10,
          oldFlag: 0,
          name: '',
        },
        total:0,
        tableData: [],
        dialog:{
          title:'',
          visible:false
        },
        referForm: {
          id: undefined,
          name:'',
          registrationTime:[],
          theoryTime:[],
          operationTime:[],
          remark:''
        },
        referRules: {
          name: [{ required: true, message: "请输入考试名称", trigger: "blur" }],
          registrationTime: [{ required: true, message: "请选择报名时间", trigger: "blur" }],
          theoryTime: [{ required: true, message: "请选择理论考试时间", trigger: "blur" }],
          operationTime: [{ required: true, message: "请选择实操考试时间", trigger: "blur" }],
          remark: [{ required: true, message: "请输入备注", trigger: "blur" }],
        },
        identity:localStorage.getItem("identity")
      }
    },
    created(){
      if(this.identity=='admin'){
        this.handleQuery()
      }
    },
    methods:{
      handleOpen(row){
        if(row){
          for(let key in this.referForm){
            if(key=='registrationTime'){
              this.referForm[key] = [row['registrationStartTime'],row['registrationEndTime']]
            }else if(key=='theoryTime'){
              this.referForm[key] = [row['theoryStartTime'],row['theoryEndTime']]
            }else if(key=='operationTime'){
              this.referForm[key] = [row['operationStartTime'],row['operationEndTime']]
            }else{
              this.referForm[key] = row[key]
            }
          }
        }
        this.dialog.title = row?'编辑':'新增'
        this.dialog.visible = true
      },
      handleCurrentChange(val) {
        this.queryParams.pageNum = val
        this.handleQuery()
      },
   
      /** 查询 */
      handleQuery() {
        this.loading = true;
        getList(this.queryParams)
          .then(({ data }) => {
            this.tableData = data.list;
            this.total = data.total;
          })
          .finally(() => {
            this.loading = false;
          });
      },
      /** 角色保存提交 */
      handleSubmit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            const roleId = this.referForm.id;
            const sub_data = {
                name:this.referForm.name,
                registrationStartTime:this.referForm.registrationTime[0],
                registrationEndTime:this.referForm.registrationTime[1],
                theoryStartTime:this.referForm.theoryTime[0],
                theoryEndTime:this.referForm.theoryTime[1],
                operationStartTime:this.referForm.operationTime[0],
                operationEndTime:this.referForm.operationTime[1],
                remark:this.referForm.remark
              }
            if (roleId) {
              editItem(roleId, sub_data)
                .then((res) => {
                  this.$message({type: 'success', message: res.message});
                  this.closeDialog();
                  this.resetQuery();
                })
                .finally(() => {
                  this.loading = false
                });
            } else {
              addItem(sub_data)
                .then((res) => {
                  this.$message({type: 'success', message: res.message});
                  this.closeDialog();
                  this.resetQuery();
                })
                .finally(() => {
                  this.loading = false
                });
            }
          }
        });
      },
      /** 关闭表单弹窗 */
      closeDialog() {
        this.dialog.visible = false;
        this.resetForm();
      },
      /** 重置表单 */
      resetForm() {
        for(let key in this.referForm){
          this.referForm[key] = []
        }
        this.referForm.id = undefined;
        this.referForm.name = '';
        this.referForm.remark = '';
        this.queryParams.pageNum = 1
        this.handleQuery()
      },
      /** 重置查询 */
      resetQuery() {
        this.queryParams.pageNum = 1;
        this.queryParams.name = ''
        this.handleQuery();
      },
      deleteItemFun(id){ 
        this.$confirm('此操作将永久删除此会员, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            delItem([id]).then((res)=>{
              this.handleQuery()
              this.$message({
                type: 'success',
                message: res.message
              });
            })
           
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消删除'
            });          
          });
      },
      handleCommand(e,id,type){
        switch (e) {
		        case 1:
		          // 考生管理
              if (type === '2') {
                  // 当type是2时跳转到(家庭教育指导师)
                  // this.$router.push({ path: '/indexPage', query: { name: '考生管理', examId: id } })
                  this.$router.push({ path: '/ksglfPage', query: { name: '考生管理', examId: id } })
              } else {
                  // 否则保持原有逻辑(心理咨询师)
                  this.$router.push({ path: '/ksglPage', query: { name: '考生管理', examId: id } })
              }
		          break;
		        case 2:
		          // 考区管理
              this.$router.push({path:'/ksglPage',query:{name:'考区管理',examId:id}})
		          break;
            case 3:
		          // 成绩管理
              this.$router.push({path:'/ksglPage',query:{name:'成绩管理',examId:id}})
		          break;
            case 4:
		          // 证书管理
              this.$router.push({path:'/ksglPage',query:{name:'证书管理',examId:id}})
		          break;
            case 5:
		          // 存档
              this.documenItemFun(id)
		          break;
		        default:
		          return;
		      }
      },
      documenItemFun(id){ 
        this.$confirm('此操作将永久存档此次记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            documenItem({id}).then((res)=>{
              this.handleQuery()
              this.$message({
                type: 'success',
                message: res.message
              });
            })
          }).catch(() => {
            this.$message({
              type: 'info',
              message: '已取消存档'
            });          
          });
      },
    }
  }
  </script>
  <style scoped lang="css" src="../../views/matrix-page/assets/css/base.css" />
  <style scoped>
  .select-box{
    width: 110px;
    height: 100%;
    position: relative;
    margin-right: 10px;
  }
  .select-box select{
    outline: none;
    width: 100%;
    height: 100%;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
  }
  .select-box:after{
    content: "";
    width: 6px;
    height: 6px;
    border-right: 1px solid #999;
    border-bottom: 1px solid #999;
    position: absolute;
    right: 10px;
    top: 82%;
    transform: rotate(45deg) translate(-50%,-50%);
    pointer-events: none;
  }
  .el-dropdown-menu__item:not(.is-disabled):hover {
    background: #71b7013a !important;
    color: #72b701 !important;
  }
	
  </style>
  <style>
   @media screen and (max-width: 600px) { 
    .el-picker-panel{
    /* transform: scale(0.7); */
    /* top: 20px !important; */
   }
   .popper__arrow{
    opacity: 0!important;
   }
  .el-picker-panel__sidebar {
    width: 375px!important;
    
  }
  .el-picker-panel {
    width: 375px!important;
  }
  .el-picker-panel__content {
    width: 375px!important;
  }
  .el-picker-panel__body{
    margin-left: 0!important;
    display: flex;
    flex-direction: column;
    min-width: auto!important;
  }
  .el-picker-panel__sidebar {
    position: relative!important;
  }
  .el-picker-panel__body-wrapper {
    display: flex!important;
    flex-direction: column!important;
    align-items: center!important;
  }
    }

 </style>